import { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import './Projects.css'

function Projects() {
  const [projects, setProjects] = useState([])
  const [loading, setLoading] = useState(true)

  const getDescriptionText = (desc) => {
    if (typeof desc === 'string') return desc
    if (Array.isArray(desc)) {
      return desc
        .map(block => block.children?.map(child => child.text).join('') || '')
        .join(' ')
    }
    return ''
  }

  const getImageUrl = (image) => {
    if (!image) return null
    if (Array.isArray(image.data)) {
      return image.data[0]?.attributes?.url
    }
    return image.data?.attributes?.url || image.url
  }

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const response = await fetch(`${import.meta.env.VITE_API_URL}/api/projects?populate=*`)
        const data = await response.json()
        const projects = (data.data || []).map(item => ({
          id: item.id,
          ...item.attributes
        }))
        setProjects(projects)
      } catch (error) {
        console.error('Error fetching projects:', error)
      } finally {
        setLoading(false)
      }
    }

    fetchProjects()
  }, [])

  return (
    <div className="projects">
      <h1>Onze Projecten</h1>
      <p className="subtitle">Showcase van ons beste carwrap werk</p>

      {loading ? (
        <div className="loading">Projecten worden geladen...</div>
      ) : projects.length === 0 ? (
        <div className="no-projects">
          <p>Nog geen projecten beschikbaar. Kom binnenkort terug!</p>
        </div>
      ) : (
        <div className="projects-grid">
          {projects.map((project) => (
            <Link key={project.id} to={`/projects/${project.id}`} className="project-card-link">
              <div className="project-card">
                {project.image && getImageUrl(project.image) && (
                  <img src={`${import.meta.env.VITE_API_URL}${getImageUrl(project.image)}`} alt={project.title} className="project-image" />
                )}
                <div className="project-info">
                  <h3>{project.title}</h3>
                  {/* <p>{getDescriptionText(project.description)}</p> */}
                  {project.date && (
                    <p className="project-date">{new Date(project.date).toLocaleDateString()}</p>
                  )}
                </div>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  )
}

export default Projects
